import { Box, styled } from "@mui/material";
import { H3, P1 } from "./Typography";

const FeaturesContainer = styled(Box)(() => ({
  display: "flex",
  gap: "16px",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  "@media (max-width: 900px)": {
    flexDirection: "column",
  },
}));

const FeatureCard = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  padding: "30px",
  backgroundColor: "var(--background-content)",
  borderRadius: "32px",
  flex: 1,
  "@media (max-width: 600px)": {
    padding: "20px",
    gap: "12px",
    borderRadius: "24px",
  },
}));

const FeatureTitle = styled(H3)(() => ({
  color: "var(--brand-primary)",
  "@media (max-width: 600px)": {
    fontSize: "20px",
    lineHeight: "24px",
  },
}));

const FeatureDescription = styled(P1)({
  color: "var(--text-tertiary)",
  "@media (max-width: 600px)": {
    fontSize: "14px",
    lineHeight: "20px",
  },
});

export interface Feature {
  title: string;
  description: string;
}

interface FeaturesSectionProps {
  features: Feature[];
}

export const FeaturesSection = ({ features }: FeaturesSectionProps) => {
  return (
    <FeaturesContainer>
      {features.map((feature, index) => (
        <FeatureCard key={index}>
          <FeatureTitle variant="h4">{feature.title}</FeatureTitle>
          <FeatureDescription variant="body2">
            {feature.description}
          </FeatureDescription>
        </FeatureCard>
      ))}
    </FeaturesContainer>
  );
};
